import React, { useEffect, useRef } from 'react'
import { Route, Switch } from 'react-router-dom'
// core components
import AdminSidebar from '../components/Sidebar/AdminSidebar'

import routes from '../routes'
import { Box } from '@mui/material'

function SuperAdmin(props) {
  var divRef = useRef(null)
  // Dispatch fills the screen; a footer under it only forces a page scroll.

  useEffect(() => {
    document.documentElement.scrollTop = 0
    document.scrollingElement.scrollTop = 0
    divRef.current.scrollTop = 0
    // Clear vendor-scoped localStorage when entering super admin layout
    localStorage.removeItem('restaurantId')
    localStorage.removeItem('restaurantName')
    localStorage.removeItem('restaurantImage')
  }, [])

  const getRoutes = routes => {
    return routes.map((prop, key) => {
      if (prop.layout === '/super_admin') {
        return (
          <Route
            path={prop.layout + prop.path}
            component={prop.component}
            key={key}
          />
        )
      } else {
        return null
      }
    })
  }
  return (
    <Box sx={{ bgcolor: '#f8fafc', minHeight: '100vh' }}>
      <AdminSidebar />
      <Box
        sx={{
          ml: { xs: 0, sm: '240px' },
          paddingTop: { xs: 10, sm: 0 },
          minHeight: '100vh',
          bgcolor: '#f8fafc'
        }}
        ref={divRef}>
        <Switch>{getRoutes(routes)}</Switch>
      </Box>
    </Box>
  )
}

export default SuperAdmin
